var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    transform: "matrix(-1 0 0 1 25 1)",
    fill: "#1B1B1B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    transform: "matrix(-1 0 0 1 25 1)",
    stroke: "#E6EBF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3028 16.5303C14.5957 16.2374 14.5957 15.7626 14.3028 15.4697L11.9745 13.1414C11.8964 13.0633 11.8964 12.9367 11.9745 12.8586L14.3028 10.5303C14.5957 10.2374 14.5957 9.76256 14.3028 9.46967C14.0099 9.17678 13.535 9.17678 13.2421 9.46967L10.4189 12.2929C10.0284 12.6834 10.0284 13.3166 10.4189 13.7071L13.2421 16.5303C13.535 16.8232 14.0099 16.8232 14.3028 16.5303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPointer);
export default __webpack_public_path__ + "static/media/LeftPointer.a6b47984e028f2cdb31d3aa06e69d334.svg";
export { ForwardRef as ReactComponent };